import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/404.svg'


const _hoisted_1 = { class: "d-flex align-items-center footer-height" }
const _hoisted_2 = { class: "container text-center" }
const _hoisted_3 = { class: "row align-items-center my-lg-7 my-md-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-6 d-none d-lg-block text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mr-5",
    src: _imports_0,
    alt: "people with thumbs up signs"
  })
], -1)
const _hoisted_5 = { class: "col col-md-9 col-lg-6 mx-auto" }
const _hoisted_6 = { class: "card shadow-sm py-3 mb-3" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "col d-flex align-items-center" }
const _hoisted_9 = {
  class: "mr-4 p-2 shadow-sm align-self-center badge badge-danger",
  style: {"font-size":"150%","border-radius":"10px"}
}
const _hoisted_10 = { style: {"font-size":"250%"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pb-3 mb-3 border-bottom" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "h2 text-monospace" }, "404! Page not Found")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted text-monospace h5" }, " The Page you are looking for does not exist ")
], -1)
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.redcastletechnology.com",
  class: "btn-lg-cus btn-secondary mt-3 font-weight-bold"
}, " Contact support ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_footer_component = _resolveComponent("footer-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_font_awesome_icon, { icon: "times-circle" })
                    ])
                  ]),
                  _hoisted_11
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (this.$router.go(-1)), ["prevent"])),
                    class: "btn-lg-cus btn-primary mt-3 font-weight-bold"
                  }, "Go Back"),
                  _createVNode(_component_router_link, {
                    to: { path: '/account/login' },
                    class: "btn-lg-cus btn-secondary mt-3 font-weight-bold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Login ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: { path: '/account/register' },
                    class: "btn-lg-cus btn-secondary mt-3 font-weight-bold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Register ")
                    ]),
                    _: 1
                  }),
                  _hoisted_13
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_footer_component)
  ], 64))
}